import { useEffect, useState } from 'react';

const useLiveBMSData = () => {
    const [liveBMSData, setLiveBMSData] = useState({});
    const deviceId = "843645465376375";

    useEffect(() => {
        const url = `${process.env.REACT_APP_API_BASE_URL}api/v1/bms/device-data/${deviceId}`;
        const interval = setInterval(() => {
            fetch(url, {
                method: 'GET',
                headers: {
                    'authorization': `Bearer ${localStorage.getItem('accessToken')}`
                },
            })
                .then(res => res.json())
                .then(data => {
                    const bmsData = data?.data[0];
                    setLiveBMSData(bmsData);
                });
            console.log(url);
        }, 5000);

        // clear function 
        return () => {
            clearInterval(interval)
        }

    }, []);

    return [liveBMSData];
};

export default useLiveBMSData;